import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from './icons';
const wordVariants = {
  hidden: {
    opacity: 0,
    y: 20,
    filter: 'blur(4px)'
  },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    filter: 'blur(0px)',
    transition: {
      duration: 0.4,
      delay: i * 0.06,
      ease: 'easeOut'
    }
  })
};
function AnimatedText({
  text,
  className
}: {
  text: string;
  className?: string;
}) {
  const words = text.split(' ');
  return <motion.p className={className} initial="hidden" whileInView="visible" viewport={{
    once: true,
    margin: '-30px'
  }} data-id="element-37">
      {words.map((word, i) => <motion.span key={i} custom={i} variants={wordVariants} className="inline-block mr-[0.3em]" data-id="element-38">
          {word}
        </motion.span>)}
    </motion.p>;
}
export function DreamTransformation() {
  return <section className="py-12 bg-brand-green-dark relative overflow-hidden" data-id="element-39">
      {/* Subtle pattern overlay */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#D4860A 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-40"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-41">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-42">
          <motion.div className="flex items-center justify-center gap-4 mb-12" initial={{
          opacity: 0,
          y: -20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} data-id="element-43">
            <motion.div animate={{
            rotate: [0, 15, -15, 0]
          }} transition={{
            duration: 4,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-44">
              <StarIcon className="w-10 h-10 text-brand-gold" data-id="element-45" />
            </motion.div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-white text-center" data-id="element-46">
              Imagina Esto...
            </h2>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30,
          rotateX: 5
        }} whileInView={{
          opacity: 1,
          y: 0,
          rotateX: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.8,
          ease: [0.16, 1, 0.3, 1]
        }} className="bg-brand-bg-dark/80 backdrop-blur-sm p-8 sm:p-12 rounded-xl border border-brand-gold/30 shadow-2xl" data-id="element-47">
            <div className="space-y-8 text-lg sm:text-xl text-gray-200" data-id="element-48">
              <AnimatedText text="Llegas a tu casa un viernes por la noche y el piso nuevo brilla. El fence está perfecto. La pared que llevaba meses rota ya no existe. El techo sellado. El patio restaurado." className="leading-relaxed" data-id="element-49" />

              <motion.div initial={{
              opacity: 0,
              scale: 0.8
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.7,
              delay: 0.3,
              type: 'spring',
              stiffness: 100
            }} className="text-2xl sm:text-3xl font-heading font-bold text-brand-gold text-center py-4" data-id="element-50">
                <span data-id="element-51">Tus vecinos lo notan. Tu familia lo nota. </span>
                <motion.span className="text-white underline decoration-brand-gold underline-offset-4 inline-block" animate={{
                y: [0, -4, 0]
              }} transition={{
                duration: 2.5,
                repeat: Infinity,
                ease: 'easeInOut',
                delay: 0.5
              }} data-id="element-52">
                  Tú lo notas.
                </motion.span>
              </motion.div>

              <AnimatedText text="No solo cambió el aspecto de tu propiedad — cambió cómo te sientes al entrar por esa puerta." className="leading-relaxed" data-id="element-53" />

              <motion.div initial={{
              opacity: 0,
              width: '0%'
            }} whileInView={{
              opacity: 1,
              width: '100%'
            }} viewport={{
              once: true
            }} transition={{
              duration: 1,
              delay: 0.5,
              ease: 'easeOut'
            }} className="mt-10 pt-8 border-t border-gray-700/50 text-center overflow-hidden" data-id="element-54">
                <motion.p initial={{
                opacity: 0,
                y: 10
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.6,
                delay: 1
              }} className="text-xl sm:text-2xl font-medium text-white" data-id="element-55">
                  Eso es lo que hace un trabajo bien hecho. Y eso es lo que{' '}
                  <strong className="text-brand-gold font-heading tracking-wide" data-id="element-56">
                    BENITEZ HANDYMAN CONSTRUCTION
                  </strong>{' '}
                  te puede dar.
                </motion.p>
              </motion.div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}